module.exports = __webpack_public_path__ + "static/media/DIS.ac41feaa.svg";